import { userInfoDecodedDataAtom } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

export const useUserInfoDataFromParams = () => {
	const { searchParams } = useRouter();
	const userInfoBase64 = searchParams.get('userInfo');
	const setUserInfoDecodedDataAtom = useSetAtom(userInfoDecodedDataAtom);

	useEffect(() => {
		if (userInfoBase64) {
			const userInfoDecodedData = Buffer.from(userInfoBase64, 'base64').toString('ascii');

			setUserInfoDecodedDataAtom(JSON.parse(userInfoDecodedData));
		}
	}, [setUserInfoDecodedDataAtom, userInfoBase64]);
};
